import requestAction from '../../utils/requestAction'

export const fetchComplaints = (params: string = "") =>
  requestAction('COMPLAINT_LIST', params)(`complaints`, 'GET')

export const fetchAllOpenComplaints = () =>
  fetchComplaints('?ownerOpenId=M')

export const fetchUnreadComplaintsCount = (handleResponse?: (count: number) => void) => {
  return requestAction('COMPLAINT_COUNT', '?status=U')(`complaints/count`, 'GET', undefined, undefined, undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.count) })
}